<template>
  <div class="main">
    <toptab></toptab>
    <div class="mainouter whiteback paddingall">
      <div class="firstinfo">
        <div class="maintitle animated fadeInUp">
          <b>主营产品展示</b>
        </div>
        <div class="maintabs animated fadeInUp">
          <template v-for="(item) in tabs">
            <div class="maintab" :key="item.id" @click="tabClick(item.id)" :class="active==item.id? 'active':''">
              <a href="javascript:void(0);">
                <div style="width:100%">{{item.name}}</div>
              </a>
            </div>
          </template>
        </div>
        <div class="goodslist" v-if="!isSmall">
          <template v-for="(item) in goodslist['list'+active]">
            <gooditem :key="item.id" :project="item"></gooditem>
          </template>
        </div>
        <div class="goodslist" v-if="isSmall">
          <template v-for="(item) in goodslist['list'+active]">
            <gooditemitem :key="item.id" :project="item"></gooditemitem>
          </template>
        </div>
        <div class="morebtn" v-if="showBtn">
          <a href="javascript:void(0);">
            <img src="../../static/morebtn.png" alt @click="loadMore" />
          </a>
        </div>
      </div>
    </div>
    <footeritem></footeritem>
  </div>
</template>

<script>
import toptab from "../components/top-tab-item";
import footeritem from "../components/footer-item";
import gooditem from "../components/short-project-item";
import gooditemitem from "../components/short-project-item copy";
import $ from 'jquery';
export default {
  components: {
    toptab,
    footeritem,
    gooditem,
    gooditemitem
  },
  data() {
    return {
      tabs: [],
      active: 0,
      goodslist: {},
      current_page: "",
      next_page_url: "",
      last_page: "",
      noMoreClick: false,
      showBtn: true,
      pageact: {},
      actEnd: {},
      isSmall: false
    }
  },
  mounted() {
    // window.sth = this;
    this.loadData();
    this.$nextTick(() => {
      require('../../utils/home');
      this.$e.$on("smallWindow", () => {
        console.log(this.isSmall);
        this.isSmall = true
      })
      this.$e.$on("bigWindow", () => {
        console.log(this.isSmall);
        this.isSmall = false
      })
    })
  },
  methods: {
    //tab点击
    tabClick(e) {
      console.log(e, this.active);
      if (this.active == e) {
        return
      }
      this.active = e
      if (this.actEnd["end" + e]) {
        this.showBtn = false
      } else {
        this.showBtn = true
      }
      this.loadMore()
    },
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.getProductTypeList, {})
        .then(res => {
          console.log(res.data);
          let { error_code, productTypeLists } = res.data;
          if (error_code == 2001) {
            this.tabs = productTypeLists.reverse()
            this.tabs.unshift({ id: 0, name: "全部" })
            this.tabs.forEach((v, i) => {
              this.$set(this.pageact, "page" + v.id, 0)
              this.$set(this.goodslist, "list" + v.id, [])
              this.$set(this.actEnd, "end" + v.id, false)
            })
            this.active = this.tabs[0].id
            this.loadMore()
            this.$nextTick(() => {
              $('.mainitem').addClass('animation-scale-up')
            })
          }
        });
    },
    loadMore() {
      if (this.actEnd["end" + this.active]) {
        this.showBtn = false
        return
      }
      let { current_page, next_page_url, last_page, noMoreClick } = this
      if (noMoreClick) {
        return
      }
      let page = this.pageact["page" + this.active]
      page += 1
      this.pageact["page" + this.active] = page
      this.noMoreClick = true
      let url = ""
      url = this.$url.getProductList
      let active = this.active
      this.$axios.post(url, { type: this.active, page })
        .then(res => {
          console.log(res.data);
          let { error_code, productLists } = res.data;
          if (error_code == 2001) {
            this.goodslist["list" + active] = this.goodslist["list" + active].concat(productLists.data)
            this.$nextTick(() => {
              $('.mainitem').removeClass('animation-scale-up')
              $('.mainitem').addClass('animation-scale-up')
            })
            if (productLists.last_page <= this.pageact["page" + active]) {
              this.actEnd["end" + active] = true
            }
            if (productLists.current_page == productLists.last_page) {
              this.showBtn = false
            } else {
              this.next_page_url = productLists.next_page_url.match(/\/api.*/)[0]
            }
          }
          this.noMoreClick = false
        })
        .catch(() => {
          this.noMoreClick = false
        })
    },
  }
}
</script>

<style scoped>
@import "../css/animate.min.css";
@import "../css/padding.css";
.main {
  padding-top: 0.67rem;
}

.mainouter {
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.whiteback {
  background-color: #fff;
}
.grayback {
  background-color: #f5f5f5;
}
.firstinfo {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 0.4rem;
}
.maintitle {
  font-size: 0.4rem;
  height: 0.4rem;
  border-left: 4px solid #ff6900;
  line-height: 0.4rem;
  padding-left: 0.1rem;
  margin-bottom: 0.4rem;
}
.maintabs {
  width: 100%;
  padding: 0.4rem;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  margin: 0 auto;
}
.maintab {
  width: 18%;
  min-width: 120px;
  border: 1px solid rgba(136, 136, 136, 1);
  border-radius: 2px;
  line-height: 0.3rem;
  font-size: 0.16rem;
  /* height: 0.3rem; */
  padding: 0 0.3rem;
  text-align: center;
  margin-bottom: 0.2rem;
  margin-right: 6%;
}
.maintab:hover {
  background-color: #ff6900;
  color: #fff;
  border-color: #ff6900;
}
.active {
  background-color: #ff6900;
  color: #fff;
  border-color: #ff6900;
}
.active a {
  color: #fff !important;
}
.maintab:hover a {
  color: #fff !important;
}
.mainlist {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.mainitem {
  width: 100%;
  max-width: 22%;
  position: relative;
  margin: 0 1.5%;
}
.mainitemimg {
  width: 100%;
}
.mainitemimg img {
  width: 100%;
}
.mainitemtitle {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  font-size: 0.2rem;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0.5rem;
}
.mainitem:hover .mainitemtitle {
  color: #fff;
  background-color: #ff6900;
}
.mainitemtop {
  position: absolute;
  top: 0;
  left: 0;
  width: 0.7rem;
  height: 0.7rem;
  text-align: center;
  background-color: #ff6900;
  color: #fff;
  padding-top: 0.1rem;
}
.mainiteminfoone {
  font-size: 0.3rem;
  line-height: 0.3rem;
}
.mainiteminfotwo {
  font-size: 0.1rem;
}
.morebtn {
  display: flex;
  justify-content: center;
}
.morebtn img {
  width: 2rem;
}
.goodslist {
  min-height: 4rem;
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 1440px) {
  .firstinfo {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .maintitle {
    font-size: 60px;
    line-height: 60px;
    height: 60px;
  }
  .maintabs {
    padding: 0;
    justify-content: space-between;
  }
  .maintab {
    width: 46%;
    border: 1px solid rgba(136, 136, 136, 1);
    border-radius: 2px;
    line-height: 60px;
    font-size: 40px;
    /* height: 60px; */
    text-align: center;
    margin-bottom: 40px;
    margin-right: 0;
  }

  .morebtn img {
    width: 3rem;
  }

  .goodslist {
    justify-content: space-between;
  }
}

/* 动画库 */
[class*="animation-"] {
  animation-duration: 0.5s;
  animation-timing-function: ease-out;
  animation-fill-mode: both;
}

.animation-scale-up {
  animation-name: scale-up;
}

@keyframes scale-up {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/project.vue